export enum TitleEnum {
    Mr = "031",
    Mrs = "032",
    Ms = "033",
    Other = "OTH"
}